import { useContext, Fragment } from "react";
import { Context } from "Context";
import useCheckMediaQuery from "hooks/useCheckMediaQuery";
import Accordion from "components/shared/Accordion";
import Separator from "components/shared/Separator";
import PhoneItem from "components/phone/PhoneItem";
import Heading, { HEADING_TYPES } from "components/shared/Heading";

const Phone = ({ phoneData = null }) => {
	const { config } = useContext(Context);
	const mainClass = "help-phone";
	const isMobileView = useCheckMediaQuery(config.mobileMediaQuery);

	const renderPhoneSection = (section, columns) => (
		<section
			className={`${mainClass}__section-numbers`}
			style={{
				gridTemplateColumns: `repeat(${columns}, 1fr)`,
			}}
		>
			{section?.categories?.map((category, index) => (
				<PhoneItem category={category} key={index} />
			))}
		</section>
	);

	const renderPhoneSections = ({ collapsables }) =>
		collapsables?.map((collapsable, i) =>
			isMobileView ? (
				<Accordion title={collapsable[0].name} key={i}>
					{collapsable.map((section, idx) => (
						<Fragment key={idx}>
							{renderPhoneSection(section, 1)}
							{idx < collapsable.length - 1 && (
								<Separator section="section" key={idx} />
							)}
						</Fragment>
					))}
				</Accordion>
			) : (
				collapsable.map((section, idx) => (
					<Fragment key={idx}>
						<h3 className={`${mainClass}__section-title`}>
							{section.name}
						</h3>
						{section.subtitle && (
							<p className={`${mainClass}__section-subtitle`}>
								{section.subtitle}
							</p>
						)}
						{renderPhoneSection(section, section.columns)}
						{(idx < collapsable.length - 1 || i < collapsables.length - 1) && (
							<Separator section="section" key={idx} />
						)}
					</Fragment>
				))
			)
		);

	if (!phoneData) return null;

	return (
		<Fragment>
			<div className={mainClass}>
				{phoneData.title && (
					<Heading
						type={HEADING_TYPES.h2}
						className={`${mainClass}__title`}
						content={phoneData.title}
					/>
				)}
				{phoneData.description && (
					<p
						className={`${mainClass}__description`}
						dangerouslySetInnerHTML={{ __html: phoneData.description }}
					></p>
				)}
			</div>
			{!isMobileView && <Separator section="phone" />}
			{renderPhoneSections(phoneData)}
		</Fragment>
	);
};

export default Phone;
